import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext.js";
import { Icon } from "../components/Icon.js";

/** Gates the admin shell. Shows a spinner while /me is in flight, then either
 *  renders children or kicks the visitor to /login (preserving the intended
 *  destination so we can return after sign-in). */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="flex items-center gap-sm text-on-surface-variant">
          <Icon name="sync" className="animate-spin text-primary-fixed-dim" />
          <span className="text-label-xs font-mono uppercase tracking-widest">Loading…</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
